/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Credential status for lifecycle tracking */
export enum CredentialStatus {
  Pending,
  Active,
  Revoked,
  Expired,
}

export type CredentialStatusArgs = CredentialStatus;

export function getCredentialStatusEncoder(): FixedSizeEncoder<CredentialStatusArgs> {
  return getEnumEncoder(CredentialStatus);
}

export function getCredentialStatusDecoder(): FixedSizeDecoder<CredentialStatus> {
  return getEnumDecoder(CredentialStatus);
}

export function getCredentialStatusCodec(): FixedSizeCodec<
  CredentialStatusArgs,
  CredentialStatus
> {
  return combineCodec(
    getCredentialStatusEncoder(),
    getCredentialStatusDecoder(),
  );
}
